import { render, staticRenderFns } from "./RecoveryCodeInput.vue?vue&type=template&id=651fd209"
import script from "./RecoveryCodeInput.vue?vue&type=script&lang=js"
export * from "./RecoveryCodeInput.vue?vue&type=script&lang=js"
import style0 from "./RecoveryCodeInput.vue?vue&type=style&index=0&id=651fd209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports